import type { UrlEntry, UrlRegion } from '@/types';

export const isIndexable = false;

export const urls: Record<
  'campaignForm',
  Partial<Record<UrlRegion, UrlEntry>>
> = {
  campaignForm: {},
};
